document.addEventListener('DOMContentLoaded', function () {
  // Open cart drawer when an item is added
  document.querySelectorAll('.ajax-add-to-cart').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = button.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {

        // Open the cart drawer
        const cartDrawer = document.querySelector('.amp-cart');
        if (cartDrawer) {
          cartDrawer.classList.add('amp-cart--open');
          cartDrawer.classList.remove('false'); // Remove the 'false' class when opening
          document.body.classList.add('overflow-hidden');
        } else {
          console.error('Cart drawer element not found in the DOM.');
        }

        // Fetch and update cart drawer content
        fetch('/?sections=cart-drawer')
          .then(res => {
            if (!res.ok) {
              throw new Error('Failed to fetch cart drawer content');
            }
            return res.json();
          })
          .then(sectionData => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionData['cart-drawer'], 'text/html');
            const newDrawerContent = doc.querySelector('.amp-cart-drawer');
            const existingDrawer = document.querySelector('.amp-cart-drawer');

            if (existingDrawer && newDrawerContent) {
              existingDrawer.innerHTML = newDrawerContent.innerHTML;
            } else {
              console.error('Cart drawer elements not found in the DOM.');
            }
          })
          .catch(error => {
            console.error('Error updating cart drawer:', error);
          });
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    });
  });

  // Event delegation for dynamically loaded close button and overlay
  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.amp-cart__header-close-button') ||
      event.target.closest('.amp-cart-drawer__overlay')
    ) {
      const cartDrawer = document.querySelector('.amp-cart');
      if (cartDrawer) {
        cartDrawer.classList.remove('amp-cart--open');
        cartDrawer.classList.add('false'); // Add the 'false' class when closing
        document.body.classList.remove('overflow-hidden');
      }
    }
  });
});
